<template src="./templates/index.html" />

<script type="text/ecmascript-6">
'use strict'

export default {
  name: 'Gridview',

  data () {
    return {
      visibility: false
    }
  },

  methods: {
    notProd () {
      return (
        process.env.APP_ENV !== 'production' &&
        process.env.APP_ENV !== 'preprod'
      )
    },
    isVisible () {
      return this.visibility
    },
    toogleGridview () {
      this.visibility = !this.visibility
    }
  }
}
</script>

<style lang="scss" src="./stylesheets/index.scss" module></style>
